import {
  BanknotesIcon,
  CursorArrowRaysIcon,
  DevicePhoneMobileIcon,
  KeyIcon,
  UserCircleIcon,
} from "@heroicons/react/24/solid";
import { t } from "@lingui/core/macro";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { useSelector } from "react-redux";

import { selectListOfMenuResourcesByActiveEid, selectOnboardingSessionIds } from "@/redux/app/appSelectors";
import MenuCard from "@/shared/components/MenuCard";
import { CircularProgress } from "@/shared/components/ui/circular-progress";

const SETTING_PAGES = [
  {
    titleKey: t`Password`,
    path: "/settings/password",
    icon: <KeyIcon className="h-5 w-auto" />,
  },
  {
    titleKey: t`Profile`,
    path: "/settings/profile",
    icon: <UserCircleIcon className="h-5 w-auto" />,
  },
  {
    titleKey: t`Security`,
    path: "/settings/mfa",
    icon: <DevicePhoneMobileIcon className="h-5 w-auto" />,
  },
  {
    titleKey: t`Cookies`,
    path: "/settings/cookies",
    icon: <CursorArrowRaysIcon className="h-5 w-auto" />,
  },
  {
    titleKey: t`Payment Methods`,
    path: "/settings/payment-methods",
    icon: <BanknotesIcon className="h-5 w-auto" />,
    menuAcl: "settings.payment-methods",
  },
];

const getSettingsPages = (aclMenu: string[], hasOnboardingSessions: boolean) => {
  const pages = SETTING_PAGES.filter((page) => !page.menuAcl || aclMenu.includes(page.menuAcl));

  // // Add onboarding option if user has no existing sessions
  // if (!hasOnboardingSessions) {
  //   pages.push({
  //     titleKey: "settings.onboarding",
  //     path: "/settings/onboarding",
  //     icon: <RocketLaunchIcon className="h-5 w-auto" />,
  //   });
  // }

  return pages;
};

function SettingsPage() {
  const aclMenu = useSelector(selectListOfMenuResourcesByActiveEid);
  const onboardingSessions = useSelector(selectOnboardingSessionIds);
  const settingsPages = getSettingsPages(aclMenu, onboardingSessions.length > 0);

  return (
    <MenuCard menuItems={settingsPages} menuLabel={t`Select a Setting`}>
      <div className="relative min-h-[200px] w-full p-6">
        <Suspense fallback={<CircularProgress className="absolute inset-0 m-auto" />}>
          <div className="mx-auto w-full">
            <Outlet />
          </div>
        </Suspense>
      </div>
    </MenuCard>
  );
}

export const Route = createFileRoute("/_authenticated/settings")({
  component: SettingsPage,
});
